import { render } from "./POSuggestions.vue?vue&type=template&id=63503355"
import script from "./POSuggestions.vue?vue&type=script&lang=js"
export * from "./POSuggestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__